// extracted by mini-css-extract-plugin
export default {"container":"CustomUserMessage_container__mRF42"};